import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Tooltip from "@material-ui/core/Tooltip";
import { instance } from "../../../../../Actions/AxiosInstance";
import {
  setHelperText,
  ShiftPlanner,
} from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import SelectList from "../../../../../Component/SelectList/SelectList";

const styles = (theme) => ({
  root: {
    width: "90%",
  },
  backButton: {
    marginRight: theme.spacing.unit,
  },
  instructions: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
});

class ShiftCategory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shiftTypeList: [],
      isflexible: false,
      shiftType: 1,
      shiftcategoryid: "",
      helperText: "",
    };

    this.onBeforeUpload = this.onBeforeUpload.bind(this);
  }

  componentWillMount() {
    this.GetShiftTypeList();
    this.props.ChangeLanguage("allshiftplanner");
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.onBeforeUpload);
    // if(this.props.Language.allshiftplanner){
    //     let text = this.props.Language.allshiftplanner.LbShiftName
    //     this.props.setHelperText({ helperText: text});
    // }
    const shiftPlannerInfo = this.props.shiftPlannerReducer;

    if (!this.isEmpty(shiftPlannerInfo)) {
      // let shiftType = shiftPlannerInfo.shiftType ? shiftPlannerInfo.shiftType : 1
      const shiftcategoryid = shiftPlannerInfo.shiftcategoryid
        ? shiftPlannerInfo.shiftcategoryid
        : 1;
      const isflexible = shiftPlannerInfo.isflexible
        ? shiftPlannerInfo.isflexible
        : false;
      this.setState({ isflexible, shiftcategoryid });
    }

    this.props.onRef({
      onNext: this.OnSave,
    });
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUpload);
  }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }

  componentWillReceiveProps(props) {
    const shiftPlannerInfo = props.shiftPlannerReducer;
    if (!this.isEmpty(shiftPlannerInfo)) {
      // let shiftType = shiftPlannerInfo.shiftType ? shiftPlannerInfo.shiftType : 1
      const shiftcategoryid = shiftPlannerInfo.shiftcategoryid
        ? shiftPlannerInfo.shiftcategoryid
        : 1;
      const isflexible = shiftPlannerInfo.isflexible
        ? shiftPlannerInfo.isflexible
        : false;

      this.setState({ isflexible, shiftcategoryid });
    }
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
  }

  UpdateShiftPlannerReducer() {
    const shiftPlannerInfo = this.props.shiftPlannerReducer;
    shiftPlannerInfo.shiftcategoryid = this.state.shiftcategoryid;
    // shiftPlannerInfo.shiftType = this.state.shiftType ? this.state.shiftType : 1
    shiftPlannerInfo.isflexible = this.state.isflexible
      ? this.state.isflexible
      : false;
    if (this.state.isflexible) {
      shiftPlannerInfo.shifttiming = shiftPlannerInfo.shifttiming
        ? [
            {
              actualshiftend: shiftPlannerInfo.shifttiming[0].actualshiftend,
              earlycutoff: shiftPlannerInfo.shifttiming[0].earlycutoff,
              endcutoff: shiftPlannerInfo.shifttiming[0].endcutoff,
              shiftbegintime: shiftPlannerInfo.shifttiming[0].shiftbegintime,
             // shiftendtime: shiftPlannerInfo.shifttiming[0].shiftendtime,
              //shiftendtime: "08:59:00",
              shiftendtime: shiftPlannerInfo.shifttiming[0].shiftbegintime && shiftPlannerInfo.shifttiming[0].shiftbegintime == "10:00:00" ? "08:59:00" : shiftPlannerInfo.shifttiming[0].shiftendtime ? shiftPlannerInfo.shifttiming[0].shiftendtime : "08:59:00",
              shifttimingid: 0,
              shiftsequence: 1,
              EarlyHrs: 0,
              EarlyMin: 30,
              EndHrs: 0,
              EndMin: 30,
              isdaynight: true,
              displayname: "one's",
              disable: false,
            },
          ]
        : [
            {
              actualshiftend: "23:29:00",
              earlycutoff: "00:30:00",
              endcutoff: "00:30:00",
              shiftbegintime: "00:30:00",
              // shiftendtime: "22:59:00",
              shiftendtime: "08:59:00",
              shifttimingid: 0,
              shiftsequence: 1,
              EarlyHrs: 0,
              EarlyMin: 30,
              EndHrs: 0,
              EndMin: 30,
              isdaynight: true,
              displayname: "One's",
              disable: false,
            },
          ];
      shiftPlannerInfo.isdaynight = true;
    }
    this.props.ShiftPlanner({ ...shiftPlannerInfo });
  }

  OnNameChange(e) {
    this.setState({ name: e.target.value });
  }

  OnSave = () => {
    this.UpdateShiftPlannerReducer();
    this.props.click();
  };

  GetShiftTypeList() {
    instance
      .get("superuser/getmastercode/ShiftCategory")
      .then((result) => {
        let shiftTypeList = [];
        result.data.result.length > 0
          ? (shiftTypeList = result.data.result)
          : (shiftTypeList = []);
        // shiftTypeList.push({ "displayname": "School", "displayvalue": 0 }, ...result.data.result)
        this.setState({ shiftTypeList });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  OnCancel() {
    this.props.Cancel(true);
  }

  HelperSliderFlag(HtField) {
    const text = get(this.props, `Language.allshiftplanner[${HtField}]`);
    // let text = this.props.Language.allshiftplanner[HtField]
    this.props.setHelperText({ helperText: text, open: true });
  }

  UpdateSelectedId(name, HtField, e) {
    this.HelperSliderFlag(HtField);
    this.setState(
      { [name]: e.target.value, isflexible: e.target.value != 1 && false },
      () => {
        this.UpdateShiftPlannerReducer();
      },
    );
  }

  updateFlexibleshift(HtField, selectedIndex) {
    this.HelperSliderFlag(HtField);
    this.setState(
      {
        isflexible: selectedIndex.displayvalue,
        Eronflexibleshiftchange: false,
      },
      () => {
        this.UpdateShiftPlannerReducer();
      },
    );
  }

  render() {
    const flexibleshiftMode = [
      {
        displayvalue: true,
        displayname: <FormattedMessage id="LbYes" defaultMessage="Yes" />,
      },
      {
        displayvalue: false,
        displayname: <FormattedMessage id="LbNo" defaultMessage="No" />,
      },
    ];
    return (
      <Grid container>
        <Grid item xs={12} md={12} sm={12}>
          <div className="stepper-scroller padding-top-0">
            <div className="stepper-scroller-content">
              <p className="form-sub-header">
                <FormattedMessage
                  id="Lbsshiftcount"
                  defaultMessage="How many shifts are there in one day?"
                />
              </p>
              <div className="device-wrapper">
                <div className="form-group">
                  <p className="form-input-label">
                    <FormattedMessage
                      id="LbShiftcount"
                      defaultMessage="Select shift"
                    />
                  </p>
                  <select
                    className="add-lefe-input"
                    onChange={this.UpdateSelectedId.bind(
                      this,
                      "shiftcategoryid",
                      "Lbsshiftcount",
                    )}
                    value={this.state.shiftcategoryid}
                  >
                    {this.state.shiftTypeList.map((row) => (
                      <option value={row.displayvalue} name={row.displayname}>
                        {row.displayname}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              {this.state.shiftcategoryid == 2 ||
              this.state.shiftcategoryid == 3 ? (
                ""
              ) : (
                <div className="device-wrapper">
                  <div className="form-group">
                    <div className="display-flex">
                      <p className="form-input-label margin-right-16">
                        <FormattedMessage
                          id="Lbflexibleshift"
                          defaultMessage="Is this shift a flexible-shift?"
                        />
                      </p>
                      <Tooltip
                        title=" Flexible shift (or flexi-shift) can be used in situations where you don't expect a fixed time slot for employees to begin/end their shift at. If you choose flexi-shift, we'll only expect you to provide a 'Begin time' for this shift. The shift will automatically end 30mins prior to the next day's begin time."
                        placement="top"
                      >
                        <p className="small-dark-secondary">💡</p>
                      </Tooltip>
                    </div>
                    <SelectList
                      data={flexibleshiftMode}
                      Selected={this.state.isflexible}
                      onSelected={this.updateFlexibleshift.bind(
                        this,
                        "Lbflexibleshift",
                      )}
                    />
                  </div>
                </div>
              )}
              {/* <Button variant="contained" color="primary" size="large" onClick={this.OnSave.bind(this)}>
                <FormattedMessage id="BtNext" defaultMessage="next" />
              </Button> */}
            </div>
          </div>
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  shiftPlannerReducer: state.shiftPlannerReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      ShiftPlanner: (data) => ShiftPlanner(data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(ShiftCategory)));

